<template>
  <transition name="modal-fade">
    <div id="modalEditBanner" class="dibble-modal">
      <div class="modal small-m">
        <div
          class="modal-dialog modal-form "
          role="document"
          style="width: 600px"
        >
          <div class="modal-content" style="min-width: 600px !important;">
            <div class="modal-header">
              <p class="title-modal">Import User From DockMaster</p>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              >
              <img src="../../../../assets/images/close-dialog.svg" alt="close-icon">
              </button>
            </div>
            <div class="modal-body form-box mt-2">
              <div class="user-modal-content" style="overflow: hidden">
                <div class="row mt-2 pl-2 pr-2 pb-5">
                  <div class="col-md-12">
                    <h5 style="text-transform: capitalize">Please enter DockMaster account number</h5>
                    <div class="form-group">
                      <div>
                        <input type="text" class="form-control" id="account-number" v-model="accountNumber" placeholder="DockMaster account number">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="d-flex justify-content-center mt-2">
                  <button v-text="'Cancel'"
                          class="btn-dialog btn-sm" @click="closeModal">
                  </button>
                  <button v-text="'Import'"
                          :disabled="!accountNumber"
                          class="ml-2 btn-dialog btn-sm ok-btn" @click="importUser">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

// import DibbleAPI from "@/api";

import DibbleJS from "@/dibble";
import DibbleAPI from "@/api";

export default {
  name: "ModalImportUser",
	props: {
		userId: String
	},
  data() {
    return {
      accountNumber: ''
    };
  },
  methods: {
    importUser() {
        DibbleJS.showLoader()
        DibbleJS.callApiRequest({
            request: DibbleAPI.api.addAppUserFromDm,
            dm_user_id: this.accountNumber
        }, (response) => {
            DibbleJS.hideLoader();
            if (DibbleAPI.isResponseSuccess(response)) {
                DibbleJS.toastSuccessMessage(response.message)
                this.$router.push(`/moorage-payment/${response.user_id}`)
            } else {
                DibbleJS.toastErrorMessage(response.message)
            }
        }, this._onRequestFailed)
    },
    closeModal() {
      this.$emit("close");
    },
    _onRequestFailed(error) {
      DibbleJS.hideLoader();
      console.log(error)
      DibbleJS.toastErrorMessage('Something wrong! can not load data');
    },
  },
};
</script>

<style lang="scss" scoped>
	.modal-content {
		min-width: 500px !important;
	}
	.modal-content, .modal-body {
		background: #C2D8DD !important;
		border-radius: 60px !important;
		padding: 10px 20px;
	}
	.modal-header {
		display: flex !important;
		justify-content: space-between !important;
		align-items: center;
		padding: 10px 0px !important;
		border-bottom: 1.5px solid #1C5169;
		margin: 0 20px !important;
		.title-modal {
			font-family: 'Open Sans';
			font-style: normal;
			font-weight: 700;
			font-size: 22px;
			line-height: 22px;
			letter-spacing: 0.01em;
			color: #1C5169;
			margin-top: 0 !important;
		}
		button {
			border: none !important;
			outline: none !important;
			background: initial;
		}
	}
  .user-modal-content {
    max-height: 500px;
    overflow: scroll;
  }
  .btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
  }
</style>
